import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Apiservice from "../Apiservice";

const PaylipList = () => {

    const location = useLocation();
    const staffId = location.state?.staffId;

    const [paySlip, setPaySlip] = useState([]);

    useEffect(() => {
        if (!staffId) return;

        const fetchData = async () => {
            let data = {
                userId: staffId,
                startPeriod: "2025-01-01",
                status: 0
            };

            let result = await Apiservice.PayslipGet(data);

            if (result.success === true) {
                setPaySlip(result.data);
            } else {
                alert(result.message);
            }
        };

        fetchData();
    }, [staffId]);

    return (
        <div
            style={{
                background: "#f9fafb",
                minHeight: "100vh",
                padding: "30px",
                fontFamily: "Arial, sans-serif"
            }}
        >
            <h2
                style={{
                    marginBottom: "25px",
                    color: "#111827",
                    fontWeight: 700,
                    letterSpacing: "0.3px"
                }}
            >
                PaySlip History
            </h2>

            <div
                style={{
                    background: "#ffffff",
                    padding: "20px",
                    borderRadius: "14px",
                    boxShadow: "0px 4px 14px rgba(0,0,0,0.06)"
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "14px"
                    }}
                >
                    <thead>
                        <tr>
                            {["Sl.No", "Date", "Period", "Mode", "Amount", "Action"].map(
                                (title, index) => (
                                    <th
                                        key={index}
                                        style={{
                                            textAlign: "left",
                                            padding: "12px 8px",
                                            fontWeight: "600",
                                            color: "#374151",
                                            borderBottom: "2px solid #f3f4f6",
                                            background: "#f9fafb"
                                        }}
                                    >
                                        {title}
                                    </th>
                                )
                            )}
                        </tr>
                    </thead>

                    <tbody>
                        {paySlip.length > 0 ? (
                            paySlip.map((item, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        borderBottom: "1px solid #f1f1f1",
                                        transition: "0.2s"
                                    }}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.background = "#fcfcfc")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.background = "transparent")
                                    }
                                >
                                    <td style={{ padding: "12px 8px" }}>{index + 1}</td>

                                    <td style={{ padding: "12px 8px" }}>
                                        {item.dateOfPayment}
                                    </td>

                                    <td style={{ padding: "12px 8px" }}>
                                        {item.periodStart}
                                        <span style={{ margin: "0 5px", color: "#6b7280" }}>
                                            to
                                        </span>
                                        {item.periodEnd}
                                    </td>

                                    <td style={{ padding: "12px 8px" }}>{item.mode || "-"}</td>

                                    <td
                                        style={{
                                            padding: "12px 8px",
                                            fontWeight: "600",
                                            color: "#059669"
                                        }}
                                    >
                                        ₹ {item.netPay}
                                    </td>

                                    <td style={{ padding: "12px 8px" }}>
                                        <button
                                            style={{
                                                padding: "6px 14px",
                                                background: "#2563eb",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "6px",
                                                fontSize: "12px",
                                                cursor: "pointer",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                                transition: "0.2s"
                                            }}
                                            onMouseOver={(e) =>
                                                (e.target.style.background = "#1d4ed8")
                                            }
                                            onMouseOut={(e) =>
                                                (e.target.style.background = "#2563eb")
                                            }
                                        >
                                            Download
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={6}
                                    style={{
                                        textAlign: "center",
                                        padding: "25px",
                                        color: "#6b7280",
                                        fontSize: "15px",
                                        fontStyle: "italic"
                                    }}
                                >
                                    No Payslip Records Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PaylipList;
